import axios from 'axios';
import Cookies from 'universal-cookie';
import AppConstants from '../../Constants/AppConstants';

const cookies = new Cookies();

export default async function gen_open_ai_resp(params) {
  try {
    // Get environment and auth key from cookies
    // Get environment and auth key from cookies
    const evn = AppConstants.cookieEnvironment;
    const authKey = cookies.get(`ck_${evn}_a`);
    if (!authKey) {
      console.error('Auth key not found in cookies');
      return {};
    }

    // Build messages array
    const messages = [];

    // Add system instruction if provided
    if (params.system_instruction) {
      messages.push({
        role: 'system',
        content: params.system_instruction,
      });
    }

    // Add user message with JSON instruction if using json_object response format
    let userContent = params.user_message;
    // if (
    //   params.user_message &&
    //   !params.user_message.toLowerCase().includes('json')
    // ) {
    //   userContent += '\n\nPlease respond with a valid JSON object.';
    // }
    messages.push({
      role: 'user',
      content: userContent,
    });

    // Build request data
    const requestData = {
      // Owl sends headers at once and pads while waiting, so replies over 10s are not dropped by the WAF
      keepalive: true,
      request: {
        // response_format: {type: 'json_object'},
        model: params.model || 'gpt-6-luna',
        messages: messages,
      },
    };

    // Add optional parameters
    if (params.temperature !== undefined) {
      requestData.request.temperature = params.temperature;
    }

    if (params.max_tokens) {
      requestData.request.max_completion_tokens = params.max_tokens;
    }

    const op_resp = await axios({
      url: 'https://api.tradly.app/v1/ai_services/response',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Auth-Key': authKey,
      },
      data: requestData,
    });

    const response = op_resp?.data;

    // Map the new API response to match expected structure
    const data_resp = {
      id: response?.id || '',
      created_at: response?.created || '',
      system_fingerprint: response?.system_fingerprint || '',
      model: params.model,
      ai_type: params.ai_type,
      ai_response: response?.data?.response || '',
      finished_reason: response?.data?.finish_reason || '',
      prompt_tokens: response?.data?.usage?.prompt_tokens || 0,
      completion_tokens: response?.data?.usage?.completion_tokens || 0,
      total_tokens: response?.data?.usage?.total_tokens || 0,
    };

    return data_resp;
  } catch (error) {
    console.log({error});
    return {};
  }
}
